<template>
    <div>
        <div class="card-body">
            <h4 class="card-title m-t-40">Escrow Amount:</h4>
            <h6 v-if="trade.total_amount">{{trade.total_amount | money }}</h6>

            <h4 class="card-title m-t-40">Escrow contract:</h4>
            <h6 class="card-subtitle">Funds will be escrowed at this address</h6>
            <h6 class="address">{{activeWallet.address}}</h6>
            <button @click="escrowTrade()" class="btn btn-info m-t-40" type="button">Escrow</button>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                Only release payment when you have received the commodities. This action is non-reversible. If you wish to dispute this transaction, please click on Open Dispute button below.
            </p>
        </div>
    </div>
</template>


<script>
    import _ from 'lodash';
    import Money from "../../../../../../../models/Money";

    export default {
        name: "Open",
        props: {
            trade: Object,
            events: Object
        },
        data() {
            return {
                activeWallet: {
                    address: null
                },
                activeWalletId: null,
                balance: null,
                selected: 2,
                options: []
            }
        },
        beforeMount() {
            this.init();
        },
        methods: {
            async init() {
                await this.getAddresses();
                await this.getBalance();
            },
            async getAddresses() {
                try {
                    let response = await this.$http.get("/wallets/addresses");
                    if(response.data !== null && response.data.length > 0) {
                        this.activeWallet   = _.find(response.data, {status: 'ACTIVE'});
                        this.activeWalletId = _.find(response.data, {status: 'ACTIVE'}).id;
                    }
                } catch(e) {
                    console.log(err);
                }
            },
            async escrowTrade() {
                let amount  = new Money({
                    amount: this.trade.total_amount.amount,
                    currency_id: this.balance.currency_id,
                    currency_name: this.balance.currency_name,
                    currency_symbol: this.balance.currency_symbol
                });
                let balance = new Money(this.balance);

                if(amount.gt(balance)) {
                    this.$toastr('error', 'Insufficient Balance to create escrow', 'Failure');
                    return;
                }

                try {
                    $(".preloader").fadeIn();
                    await this.$http.post('/trades/' + this.trade.trade_id + '/escrow', {from: this.selectedAddress, comments: ''});
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Your escrow has been processed successfully.', 'Escrow Deposited');
                    this.events.$emit('trade:reload');
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                    this.$toastr('error', 'Escrow process failed', 'Failure');
                }
            },
            async getBalance() {
                if(this.activeWalletId) {
                    let balance  = await this.$http.get(`/wallets/${this.activeWalletId}/balance`);
                    this.balance = balance.data;
                }
            }
        }
    }
</script>

<style scoped>
    h6.address {
        font-family: Source Code Pro, monospace;
        color: #4f5382;
        font-size: 12px;
    }

    select.address {
        font-family: Source Code Pro, monospace;
        font-weight: 700;
        color: #4f5382;
        font-size: 12px;
    }

    .select2-selection__rendered {
        display: block;
        padding-left: 8px;
        padding-right: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: Source Code Pro, monospace;
        font-weight: 700;
        color: #4f5382;
        font-size: 12px;
    }

</style>
